const en = require('./resources/en.json');

export default {
    messages: en,
    formats: {
        date: {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            },
        },
        number: {
            price: {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};
